import { inject } from '@angular/core';
import { DIRECT_TICKETS_SCHEMA, IDirectTicket } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { IListGateway } from '../../gateways';

export interface IRelationTicketRequest {
  serviceAreaId: number;
  origin: string;
  destination: string;
  dateTime: string;
  via?: string;
}

export class ActiveRelationTicketGateway implements IListGateway<
  IRelationTicketRequest,
  IApiResponse<IDirectTicket[]>
> {
  private readonly listRestCallBuilder: RestCallBuilder<
    IRelationTicketRequest,
    IDirectTicket[]
  > = new RestCallBuilder<IRelationTicketRequest, IDirectTicket[]>([]);

  private readonly configService: AppConfigService = inject(AppConfigService);

  list(
    request: IRelationTicketRequest
  ): Observable<IApiResponse<IDirectTicket[]>> {
    return this.listRestCallBuilder
      .getExternal(
        //@TODO remove /all once testing winds down
        this.configService.get().general.directTicketUrl +
          '/tickets/relation/all',
        {
          ...request,
        }
      )
      .validate(API_RESPONSE_SCHEMA(DIRECT_TICKETS_SCHEMA), 'DirectTicket.list')
      .handleMessages()
      .build();
  }
}
